import { contextFactory } from '@frontend/design-system';
import { UsePreferredSourceTenantsResults } from './usePreferredSourceTenants';

export const [DigitalFormsPreferredSourceTenantsContext, useDigitalFormsPreferredSourceTenantsContext] =
  contextFactory<UsePreferredSourceTenantsResults>(
    'useDigitalFormsPreferredSourceTenantsContext must be used within a DigitalFormsPreferredSourceTenantsContext'
  );
